import React from 'react';
import './index.scss';

import logoRecruit from 'assets/logo-recruit.png';

const PcFooter = () => (
  <div className="PcFooter">
    <div className="logo-area">
      <a href="/corporate/" target="_blank" rel="noopener noreferrer">
        <img className="logo-recruit" src={logoRecruit} alt="logo-recruit" />
      </a>
      <a href="/corporate/" target="_blank" rel="noopener noreferrer">
        <div className="company-limited">(C) Recruit Staffing Co., Ltd.</div>
      </a>
    </div>
  </div>
);

export default PcFooter;